import React, { ReactElement } from 'react';
import AppRouter from 'router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProvider } from 'styled-components';
import { ReactQueryDevtools } from 'react-query/devtools';
import { QueryClient, QueryClientProvider } from 'react-query';

import { GlobalStyles, theme, themeLFL } from 'assets/styles';

import { StoreProvider } from 'store/authContext';

const queryClient = new QueryClient();

const App = (): ReactElement => {
  return (
    <QueryClientProvider client={queryClient}>
      <StoreProvider>
        <ThemeProvider
          theme={process.env.REACT_APP_THEME === 'lfl' ? themeLFL : theme}
        >
          <GlobalStyles />
          <ReactQueryDevtools />
          <ToastContainer draggable={false} />
          <AppRouter />
        </ThemeProvider>
      </StoreProvider>
    </QueryClientProvider>
  );
};
export default App;
